import React from 'react';
import { StyledDetailsReportCard, useStyles } from './styles';
import { Typography, Tooltip } from '@material-ui/core';
import moment from 'moment';
import 'moment/locale/pt-br';
import OldUserDetails from './components/oldUserDetails';
import ContainerStatusExchange from './components/containerStatusExchange';
import CurrentUserDetails from './components/currentUserDetails';

moment.locale('pt-br');

const formatScheduleFooter = (scale) => {
  if (!scale?.date_start || !scale?.date_end) return '';
  const start = moment(scale.date_start, 'DD/MM/yyyy HH:mm');
  const end = moment(scale.date_end, 'DD/MM/yyyy HH:mm');
  if (!start.isValid() || !end.isValid()) return '';
  const datePart = start.format('DD/MM [(]ddd[)]');
  const timePart = `${start.format('HH[h]mm')} às ${end.format('HH[h]mm')}`;
  return `${datePart} ${timePart}`;
};

const CardExchangeReport = ({
  exchange,
  statusType,
  openDetails = () => {},
}) => {
  const classes = useStyles();
  const scaleTitle = exchange?.scale?.name ?? '';
  const scheduleLine = formatScheduleFooter(exchange?.scale);

  return (
    <StyledDetailsReportCard elevation={0}>
      <div className={classes.cardMain}>
        <Tooltip
          title={scaleTitle}
          placement="top"
          disableHoverListener={!scaleTitle}
        >
          <Typography
            className={classes.title}
            component="span"
            display="block"
          >
            {scaleTitle}
          </Typography>
        </Tooltip>
        <OldUserDetails
          situationStatus={`${exchange?.situation}${exchange?.situation_status}`}
          userOld={exchange?.user_old}
          openDetails={openDetails}
          statusType={statusType}
          exchange={exchange}
        />
        <ContainerStatusExchange
          situationStatus={`${exchange?.situation}${exchange?.situation_status}`}
          statusType={statusType}
        />
        <CurrentUserDetails
          currentUser={exchange?.user}
          situationStatus={`${exchange?.situation}${exchange?.situation_status}`}
          openDetails={openDetails}
          statusType={statusType}
          exchange={exchange}
        />
      </div>
      {scheduleLine && (
        <div className={classes.footer}>
          <Typography component="p" className={classes.footerText}>
            {scheduleLine}
          </Typography>
        </div>
      )}
    </StyledDetailsReportCard>
  );
};

export default CardExchangeReport;
